var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumWithCircle4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4597_7465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.5C0 4.08172 3.58172 0.5 8 0.5C12.4183 0.5 16 4.08172 16 8.5C16 12.9183 12.4183 16.5 8 16.5C3.58172 16.5 0 12.9183 0 8.5Z",
    fill: "#7F8283"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65039 12.5V10.9473H4.50781V9.55859C4.72266 9.17578 4.93945 8.79688 5.1582 8.42188C5.37695 8.04297 5.59766 7.66797 5.82031 7.29688C6.04688 6.92188 6.27148 6.55273 6.49414 6.18945C6.7207 5.82227 6.94727 5.46094 7.17383 5.10547C7.40039 4.74609 7.62695 4.39258 7.85352 4.04492H10.3379V9.5293H11.4395V10.9473H10.3379V12.5H8.65039ZM6.10156 9.57617H8.68555V5.38672H8.5918C8.42773 5.64062 8.25977 5.90039 8.08789 6.16602C7.91992 6.43164 7.75 6.70312 7.57812 6.98047C7.41016 7.25781 7.24023 7.53711 7.06836 7.81836C6.90039 8.0957 6.73438 8.375 6.57031 8.65625C6.41016 8.93359 6.25391 9.20898 6.10156 9.48242V9.57617Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4597_7465"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.5C0 4.08172 3.58172 0.5 8 0.5C12.4183 0.5 16 4.08172 16 8.5C16 12.9183 12.4183 16.5 8 16.5C3.58172 16.5 0 12.9183 0 8.5Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumWithCircle4);
export default __webpack_public_path__ + "static/media/NumWithCircle_4.77195276e048c953e19d9be5aec0a53b.svg";
export { ForwardRef as ReactComponent };